import * as React from "react"
import { Link } from "gatsby"

import { Code, Line } from "@molnx-sites/common/components"
import { SideNavigation, DocPage } from "src/components"

export default function DispatchIndex() {
    return (
        <DispatchDocPage>
            <h1>Hello</h1>
            <Code>
                <Line>println("Hello, World!")</Line>
            </Code>
        </DispatchDocPage>
    )
}

export function DispatchDocPage(props: {
    children?: any
}) {
    return (
        <DocPage
            title="Dispatch"
            navigation={renderSideNavigation()}
            children={props.children}
        />
    )
}

function renderSideNavigation() {
    function linkTo(path: string, text: string) {
        return <Link to={path} activeClassName={SideNavigation.Classes.ActiveLink}>{text}</Link>
    }

    return (
        <SideNavigation>
            <ul>
                <li>{linkTo("/dispatch/", "Introduction")}</li>

                <li>
                    {linkTo("/dispatch/how-it-works/", "How it works")}
                </li>
                <li>
                    {linkTo("/dispatch/configuration", "Configuration")}
                    <ul>
                        <li>{linkTo("/dispatch/configuration/webhooks", "Webhooks")}</li>
                        <li>{linkTo("/dispatch/configuration/amazon-sqs", "Amazon SQS")}</li>
                        <li>{linkTo("/dispatch/configuration/amazon-sns", "Amazon SNS")}</li>
                    </ul>
                </li>
                <li>{linkTo("/dispatch/faq", "FAQ")}</li>
                <li>{linkTo("/dispatch/limits", "Limits")}</li>
                <li>{linkTo("/dispatch/monitoring", "Monitoring")}</li>
                <li>
                    {linkTo("/dispatch/api-reference", "API Reference")}
                    <ul>
                        <li>{linkTo("/dispatch/api-reference/authentication", "Authentication")}</li>
                        <li>{linkTo("/dispatch/api-reference/messages", "Messages API")}</li>
                        <li>{linkTo("/dispatch/api-reference/targets", "Targets API")}</li>
                        <li>{linkTo("/dispatch/api-reference/domains", "Domains API")}</li>
                        <li>{linkTo("/dispatch/api-reference/error-codes", "Error Codes")}</li>
                    </ul>
                </li>
            </ul>
        </SideNavigation>
    )
}